import { useState } from "react";
import Sidebar from "./components/Header/Sidebar"
import Header from "./components/Header/Index"
import StickyHeaderMenu from "./components/Header/StickyHeaderMenu";
import './Layout.css'
import NotificationPopover from './components/Header/NotificationPopover'
import Footer from "components/Footer";
import MobileSidebarDrawer from './components/Header/MobileSidebarDrawer'
interface LayoutProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

export default function DashboardLayout({ className, contentClassName, children }: LayoutProps) {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [notifyOpen, setNotifyOpen] = useState(false)
  return (
    <div>
      <Sidebar onToggleNotify={() => setNotifyOpen(prev => !prev)} />

      <div>
        <Header onOpenMenu={() => setDrawerOpen(true)} />
        <StickyHeaderMenu />
        <main className="container mx-auto py-4 px-0 space-y-4">
          {children}
        </main>
      </div>
      <Footer />
      <MobileSidebarDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
      <NotificationPopover
        open={notifyOpen}
        onClose={() => setNotifyOpen(false)}
      />
    </div>
  )
}